/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type SellerGroupModelList_searchSeller$ref: FragmentReference;
declare export opaque type SellerGroupModelList_searchSeller$fragmentType: SellerGroupModelList_searchSeller$ref;
export type SellerGroupModelList_searchSeller = {|
  +searchSellerGroup: ?{|
    +models: ?$ReadOnlyArray<?{|
      +sellerProductGroupId: ?string,
      +sellerProductGroupName: ?string,
      +sellerModelId: ?string,
      +sellerContactId: ?string,
      +sellerModelNumber: ?string,
      +price: ?string,
      +stocks: ?string,
      +shippingDate: ?string,
      +salesMethodMaker: ?boolean,
      +openPrice: ?boolean,
      +salesMethod: ?number,
      +salesMethodLabel: ?string,
      +specs: ?$ReadOnlyArray<?{|
        +specId: ?number,
        +specName: ?string,
        +specValue: ?string,
      |}>,
      +groupSpecs: ?$ReadOnlyArray<?{|
        +specId: ?number,
        +specName: ?string,
        +specValue: ?string,
      |}>,
      +allModelSpecsIsPresentInGroup: ?boolean,
    |}>,
    +groups: ?$ReadOnlyArray<?{|
      +sellerProductGroupId: ?string,
      +sellerProductGroupName: ?string,
      +sellerModelId: ?string,
    |}>,
    +pageMetadata: ?{|
      +totalRecords: ?number,
      +currentPage: ?number,
      +recordsFrom: ?number,
      +recordsTo: ?number,
      +noOfPages: ?number,
      +took: ?number,
      +prevPage: ?number,
      +nextPage: ?number,
      +maxNoOfPageToDisplay: ?number,
    |},
  |},
  +$refType: SellerGroupModelList_searchSeller$ref,
|};
export type SellerGroupModelList_searchSeller$data = SellerGroupModelList_searchSeller;
export type SellerGroupModelList_searchSeller$key = {
  +$data?: SellerGroupModelList_searchSeller$data,
  +$fragmentRefs: SellerGroupModelList_searchSeller$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "sellerProductGroupId",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "sellerProductGroupName",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "sellerModelId",
  "args": null,
  "storageKey": null
},
v3 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "specId",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "specName",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "specValue",
    "args": null,
    "storageKey": null
  }
];
return {
  "kind": "Fragment",
  "name": "SellerGroupModelList_searchSeller",
  "type": "SearchSeller",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "sellerContactId",
      "type": "String",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "sellerModelId",
      "type": "String",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "sellerProductGroupId",
      "type": "Int",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "offset",
      "type": "Int",
      "defaultValue": 1
    },
    {
      "kind": "LocalArgument",
      "name": "limit",
      "type": "Int",
      "defaultValue": 10
    },
    {
      "kind": "LocalArgument",
      "name": "sellerModelNumber",
      "type": "String",
      "defaultValue": ""
    },
    {
      "kind": "LocalArgument",
      "name": "specs",
      "type": "String",
      "defaultValue": ""
    },
    {
      "kind": "LocalArgument",
      "name": "stocks",
      "type": "String",
      "defaultValue": ""
    },
    {
      "kind": "LocalArgument",
      "name": "price",
      "type": "String",
      "defaultValue": ""
    },
    {
      "kind": "LocalArgument",
      "name": "shippingDate",
      "type": "String",
      "defaultValue": ""
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "searchSellerGroup",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "limit",
          "variableName": "limit"
        },
        {
          "kind": "Variable",
          "name": "offset",
          "variableName": "offset"
        },
        {
          "kind": "Variable",
          "name": "price",
          "variableName": "price"
        },
        {
          "kind": "Variable",
          "name": "sellerContactId",
          "variableName": "sellerContactId"
        },
        {
          "kind": "Variable",
          "name": "sellerModelId",
          "variableName": "sellerModelId"
        },
        {
          "kind": "Variable",
          "name": "sellerModelNumber",
          "variableName": "sellerModelNumber"
        },
        {
          "kind": "Variable",
          "name": "sellerProductGroupId",
          "variableName": "sellerProductGroupId"
        },
        {
          "kind": "Variable",
          "name": "shippingDate",
          "variableName": "shippingDate"
        },
        {
          "kind": "Variable",
          "name": "specs",
          "variableName": "specs"
        },
        {
          "kind": "Variable",
          "name": "stocks",
          "variableName": "stocks"
        }
      ],
      "concreteType": "SellerGroupProduct",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "models",
          "storageKey": null,
          "args": null,
          "concreteType": "SellerGroupProductModel",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            (v2/*: any*/),
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "sellerContactId",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "sellerModelNumber",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "price",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "stocks",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "shippingDate",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "salesMethodMaker",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "openPrice",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "salesMethod",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "salesMethodLabel",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "specs",
              "storageKey": null,
              "args": null,
              "concreteType": "SellerGroupProductModelSpec",
              "plural": true,
              "selections": (v3/*: any*/)
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "groupSpecs",
              "storageKey": null,
              "args": null,
              "concreteType": "SellerGroupProductModelSpec",
              "plural": true,
              "selections": (v3/*: any*/)
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "allModelSpecsIsPresentInGroup",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "groups",
          "storageKey": null,
          "args": null,
          "concreteType": "SellerGroupProductModelGroup",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            (v2/*: any*/)
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "pageMetadata",
          "storageKey": null,
          "args": null,
          "concreteType": "PageMetadata",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "totalRecords",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "currentPage",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "recordsFrom",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "recordsTo",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "noOfPages",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "took",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "prevPage",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "nextPage",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "maxNoOfPageToDisplay",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '7d823af6a608d33aa26de8427698e713';
module.exports = node;
